import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from './ui/Logo';

export const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-app overflow-hidden">
      {/* Background grid */}
      <div className="absolute inset-0 bg-dotgrid opacity-50" />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 60% 50% at 50% 40%, color-mix(in oklab, var(--brand) 18%, transparent), transparent 70%)',
        }}
      />

      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 flex flex-col items-center gap-8"
      >
        <Logo size={56} />

        {/* Progress bar */}
        <div className="w-56 h-1 rounded-full overflow-hidden" style={{ background: 'var(--border)' }}>
          <motion.div
            initial={{ x: '-100%' }}
            animate={{ x: '0%' }}
            transition={{ duration: 1.4, ease: [0.6, 0, 0.4, 1] }}
            className="h-full w-full"
            style={{
              background:
                'linear-gradient(90deg, var(--brand), var(--accent), var(--brand))',
              backgroundSize: '200% 100%',
            }}
          />
        </div>

        <div className="flex items-center gap-2 text-mono text-xs uppercase tracking-[0.25em] text-muted">
          <span className="loading-dot" />
          <span>Initialising</span>
          <span className="animate-blink">_</span>
        </div>
      </motion.div>
    </div>
  );
};

export default LoadingScreen;
